import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortfolioLiveResponse, PortfolioNewsResponse, SymbolSearchResponse, UserProfile } from '../models/profile.model';
import { AuthResponse, SignInPayload, SignUpPayload, UserRecord, UserUpdatePayload } from '../models/auth.model';

interface NeonRow {
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly baseUrl = ['localhost', '127.0.0.1'].includes(window.location.hostname)
    ? 'http://localhost:8000/api'
    : 'https://apipersonal.karthikeyansvp.com/api';

  constructor(private http: HttpClient) {}

  saveProfile(profile: UserProfile): Observable<UserProfile> {
    return this.http.post<UserProfile>(`${this.baseUrl}/profile`, profile);
  }

  getProfile(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.baseUrl}/profile`);
  }

  getLivePortfolio(): Observable<PortfolioLiveResponse> {
    return this.http.get<PortfolioLiveResponse>(`${this.baseUrl}/portfolio/live-direct`);
  }

  getPortfolioNews(limit: number = 3): Observable<PortfolioNewsResponse> {
    return this.http.get<PortfolioNewsResponse>(`${this.baseUrl}/portfolio/news?limit=${limit}`);
  }

  searchSymbol(query: string): Observable<SymbolSearchResponse> {
    return this.http.get<SymbolSearchResponse>(`${this.baseUrl}/symbol/search?query=${encodeURIComponent(query)}`);
  }

  getNeonData(tableName: string, limit: number = 1000): Observable<NeonRow[]> {
    return this.http.get<NeonRow[]>(
      `${this.baseUrl}/neon/getTables?table_name=${encodeURIComponent(tableName)}&limit=${limit}&_=${Date.now()}`
    );
  }

  signUp(payload: SignUpPayload): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.baseUrl}/auth/sign-up`, payload);
  }

  signIn(payload: SignInPayload): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.baseUrl}/auth/sign-in`, payload);
  }

  getUsers(limit: number = 100): Observable<UserRecord[]> {
    return this.http.get<UserRecord[]>(`${this.baseUrl}/users?limit=${limit}`);
  }

  getUserById(userId: number): Observable<UserRecord> {
    return this.http.get<UserRecord>(`${this.baseUrl}/users/${userId}`);
  }

  createUser(payload: SignUpPayload): Observable<AuthResponse> {
    return this.http.post<AuthResponse>(`${this.baseUrl}/users`, payload);
  }

  updateUser(userId: number, payload: UserUpdatePayload): Observable<AuthResponse> {
    return this.http.put<AuthResponse>(`${this.baseUrl}/users/${userId}`, payload);
  }

  deleteUser(userId: number): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.baseUrl}/users/${userId}`);
  }
}
